/* eslint-disable react/jsx-no-bind */
import * as React from "react";
import classNames from "classnames";
import { ErrorBoundary } from "~/lib/Bugsnag";
import { ErrorView } from "~/components/shared/ErrorView";
import { useNavigate } from "react-router-dom";
import Spinner from "~/components/shared/Spinner";
import { useStepsQuery } from "~/components/build/Show/lib/useSteps";
import ViewNotAvailable from "~/components/build/Show/components/Canvas/EmptyStates/ViewNotAvailable";
import { useStepDependenciesStore } from "~/components/build/Show/lib/useStepDependenciesStore";
import { useBuild } from "~/components/build/Show/lib/BuildContext";

const Canvas = React.lazy(
  () => import(/* webpackChunkName: "canvas" */ "~/components/Playground/BuildCanvas"),
);

function CanvasContent() {
  const navigate = useNavigate();
  const dependenciesByStep = useStepDependenciesStore((state) => state.dependenciesByStep);
  const { build } = useBuild();
  const { isLoading } = useStepsQuery(build);

  return (
    <ErrorBoundary
      FallbackComponent={() => <ErrorView className="px-4 py-2" clearError={() => navigate(0)} />}
    >
      <div className="relative min-w-0 flex-auto" data-testid="canvas">
        <div className="absolute flex h-full w-full overflow-y-auto">
          <div
            className={classNames(
              Features.BuildSidebar ? "" : "border border-gray-300",
              "relative flex-1 overflow-hidden rounded-md bg-white contain-layout data-[fullscreen=true]:fixed data-[fullscreen=true]:left-0 data-[fullscreen=true]:top-0 data-[fullscreen=true]:m-0 data-[fullscreen=true]:h-screen data-[fullscreen=true]:w-screen data-[fullscreen=true]:rounded-none data-[fullscreen=true]:border-none",
            )}
            id="canvas"
          >
            <div className="absolute h-full w-full">
              {(Features.ProgressiveBuildShow && isLoading) ||
              Object.keys(dependenciesByStep).length === 0 ? (
                <Spinner className="animate-fade-in-with-delay absolute right-4 top-4 z-10" />
              ) : (
                <React.Suspense fallback={null}>
                  <Canvas />
                </React.Suspense>
              )}
            </div>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
}

export default function CanvasPage() {
  // We're using a wrapper to conditionally render the canvas so that we don't end up
  // fetching or processing data for the canvas when we're not going to show it anyway
  if (Features.DisableStepsCanvasView) {
    return <ViewNotAvailable />;
  }

  return <CanvasContent />;
}
